import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from './config';

const SETTINGS_COLLECTION = 'settings';
const GENERAL_SETTINGS_ID = 'general';

export interface SiteSettings {
  heroImage?: string;
  heroTitle?: string;
  updatedAt?: Date;
}

const checkAuth = () => {
  const auth = getAuth();
  if (!auth.currentUser) {
    throw new Error('Missing or insufficient permissions.');
  }
};

export const getSettings = async (): Promise<SiteSettings> => {
  try {
    const docRef = doc(db, SETTINGS_COLLECTION, GENERAL_SETTINGS_ID);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data() as SiteSettings;
    } else {
      return {};
    }
  } catch (error) {
    console.error('Error getting settings:', error);
    throw error;
  }
};

export const updateSettings = async (settings: Partial<SiteSettings>) => {
  try {
    checkAuth();
    const docRef = doc(db, SETTINGS_COLLECTION, GENERAL_SETTINGS_ID);
    await setDoc(docRef, {
      ...settings,
      updatedAt: new Date(),
    }, { merge: true });
  } catch (error) {
    console.error('Error updating settings:', error);
    throw error;
  }
};
